import classnames from 'classnames';
import * as React from 'react';
import SvgInline from '@latitude/svg-inline';
import './_hamburger-button.scss'; // Use ref forwarding to obtain a ref to the <button> element
// https://reactjs.org/docs/forwarding-refs.html

var HamburgerButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var className = props.className,
      navOpen = props.navOpen,
      onClick = props.onClick;
  return /*#__PURE__*/React.createElement("button", {
    ref: ref,
    type: "button",
    className: classnames('hamburger-button', className, {
      'is-active': navOpen
    }),
    onClick: onClick
  }, navOpen ? /*#__PURE__*/React.createElement(SvgInline, {
    className: "icon__cross",
    name: "cross",
    ariaLabel: "close menu "
  }) : /*#__PURE__*/React.createElement(SvgInline, {
    className: "icon__hamburger",
    name: "menu",
    ariaLabel: "open menu"
  }));
});
export default HamburgerButton;